// extracted by mini-css-extract-plugin
export default {"personsWrapper":"personsField_personsWrapper__TcMkP","fieldsWrapper":"personsField_fieldsWrapper__6ZsxM"};